export const ISSUE_TRANSITION_STATUS_FIELD = 'issue-transition-status-field';
